import { Box, Paper, Skeleton, Typography } from '@mui/material';

import { DashCampaignsModelView } from '~/types';

interface ProgressCampaignProps {
  data: DashCampaignsModelView;
  isLoading: boolean;
}

export function ProgressCampaign({ data, isLoading }: ProgressCampaignProps) {
  if (isLoading) {
    return (
      <Paper sx={{ flex: '1 1 300px' }}>
        <Box
          sx={{
            backgroundColor: '#fff',
            borderRadius: '8px',
            boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.05)',
            padding: '24px',
            height: '340px',
          }}
        >
          <Skeleton
            variant="text"
            sx={{ fontSize: '1.25rem', mb: 2, width: '200px' }}
          />
          <Skeleton variant="text" sx={{ mb: 2 }} />
          {[1, 2, 3, 4, 5].map(item => (
            <Box key={item} sx={{ mb: 2 }}>
              <Box
                sx={{
                  display: 'grid',
                  gridTemplateColumns: '2fr 2fr 1fr',
                  gap: 1,
                }}
              >
                <Skeleton variant="text" />
                <Skeleton variant="text" />
                <Skeleton variant="text" />
              </Box>
            </Box>
          ))}
        </Box>
      </Paper>
    );
  }

  const campaignProgress = data?.campaignProgress ?? [];

  return (
    <Paper sx={{ flex: '1 1 300px' }}>
      <Box
        sx={{
          backgroundColor: '#fff',
          borderRadius: '8px',
          boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.05)',
          padding: '24px',
          height: '340px',
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 500, marginBottom: 2 }}>
          Andamento das campanhas
        </Typography>

        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: '2fr 2fr 1fr',
            mb: 2,
            borderBottom: '1px solid rgba(0,0,0,0.1)',
            pb: 1,
          }}
        >
          <Typography color="text.secondary">Cliente</Typography>
          <Typography color="text.secondary">Impressões</Typography>
          <Typography color="text.secondary" align="right">
            CTR
          </Typography>
        </Box>

        {Array.isArray(campaignProgress) &&
          campaignProgress.map(item => (
            <Box key={item?.advertiserName ?? 'unknown'} sx={{ mb: 2 }}>
              <Box
                sx={{
                  display: 'grid',
                  gridTemplateColumns: '2fr 2fr 1fr',
                  alignItems: 'center',
                  mb: 1,
                }}
              >
                <Typography sx={{ fontWeight: 'medium', fontSize: '14px' }}>
                  {item?.advertiserName ?? '-'}
                </Typography>
                <Typography sx={{ fontSize: '14px' }}>
                  {new Intl.NumberFormat('pt-BR').format(
                    parseInt(item?.impressions ?? '0', 10)
                  )}
                </Typography>
                <Typography align="right" sx={{ fontSize: '14px' }}>
                  {item?.ctr ?? '-'}
                </Typography>
              </Box>
            </Box>
          ))}
      </Box>
    </Paper>
  );
}
